import React, { useEffect, useState } from 'react';
import './style/index.scss';
import Entry from './page/Entry';
import { Choice } from './page/Choice';
import StudioPassGate from './page/StudioPassGate';
import { useScreenContext } from './library/context/screenview';
import { Chat } from './page/Chat/ChatV2';
import { Loader } from './components/Loader';
import useUser from './hooks/useUser';

export function Main() {
  const [isEntry, setEntry] = useState(true)
  const [hideEntry, setHideEntry] = useState(false)
  const {currentScreen} = useScreenContext();
  const { isAuthenticated, isAuthFlowCompleted, isStudioPassVip } = useUser();

  useEffect(()=>{
    setTimeout(()=>{
      setEntry(false)
    },1000)
    setTimeout(()=>{
      setHideEntry(true)
    },1500)
  },[])
  return (
      <div className="brevilleplus-wrapper">
        {/* Splash animation */}
        {!hideEntry && <Entry open={isEntry} />}

        {/* After splash: wait for Auth0 to finish determining auth state */}
        {hideEntry && !isAuthFlowCompleted && <Loader />}

        {/* Not authenticated — StudioPass VIP upsell (anonymous variant) */}
        {hideEntry && isAuthFlowCompleted && !isAuthenticated && <StudioPassGate variant="anonymous" />}

        {/* Authenticated but not StudioPass VIP — StudioPass VIP upsell (member variant) */}
        {hideEntry && isAuthFlowCompleted && isAuthenticated && !isStudioPassVip && <StudioPassGate variant="member" />}

        {/* Authenticated StudioPass VIP — normal app flow */}
        {hideEntry && isAuthFlowCompleted && isAuthenticated && isStudioPassVip && (
          <>
            {!currentScreen && <Choice/>}
            <Chat screenName={currentScreen}/>
          </>
        )}
      </div>
  );
}